import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg<{ $small?: boolean }>`
  width: ${({ $small }) => ($small ? "0.75rem" : "auto")};
  height: ${({ $small }) => ($small ? "auto" : "0.8125rem")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"svg"> {
  small?: boolean;
  className?: string;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
